export default __webpack_public_path__ + "static/media/icon-node-completed-card.cc1c8e44.svg";